import { render, staticRenderFns } from "./admin_posts.vue?vue&type=template&id=7716acc8&scoped=true&"
import script from "./admin_posts.vue?vue&type=script&lang=js&"
export * from "./admin_posts.vue?vue&type=script&lang=js&"
import style0 from "./admin_posts.vue?vue&type=style&index=0&id=7716acc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7716acc8",
  null
  
)

export default component.exports